import type React from 'react';
import { useState } from 'react';
import IconBack from '@tradera/blueprint/theme/icons2/back.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';
import styles from './accordion-next-level.module.scss';
import { HeaderWithCloseButton } from 'tradera/components/scrollable-modal/header-with-close-button';
import { classNames } from 'tradera/utils/class-names';

type AccordionNextLevelProps = {
    children: React.ReactNode;
    classNames?: { className?: string; bodyClassName?: string };
    onClose?: () => void;
    onDismiss: () => void;
    title?: string | React.ReactNode;
};

export const AccordionNextLevel = ({
    onClose,
    onDismiss,
    classNames: nextLevelClassNames,
    children,
    title,
}: AccordionNextLevelProps) => {
    const [slideOut, setSlideOut] = useState(false);

    const closeNextLevel = () => {
        setSlideOut(true);
        setTimeout(() => {
            setSlideOut(false);
            onDismiss();
        }, 400);
    };

    return (
        <div
            className={classNames(
                styles.nextLevel,
                {
                    [styles.slideOut]: slideOut,
                },
                nextLevelClassNames?.className,
            )}>
            <HeaderWithCloseButton
                onClose={onClose}
                title={title}
                border
                menu={
                    <Button
                        theme="unbutton"
                        onClick={closeNextLevel}
                        autoFocus={slideOut}>
                        <IconBack className="icon icon-dark" />
                    </Button>
                }
            />
            <div
                className={classNames(
                    styles.body,
                    nextLevelClassNames?.bodyClassName,
                )}>
                {children}
            </div>
        </div>
    );
};
